import { useTape } from "@/hooks/use-tape";
import { useT } from "@/i18n/useT";
import { PRESSURE_KEYS } from "@/config/fng";
import type { MessageKey } from "@/i18n/messages";

function pctColor(n: number | null | undefined): string {
  if (n == null || n === 0) return "text-muted-foreground/45";
  return n > 0 ? "text-positive/85" : "text-negative/85";
}

function fmtPct(n: number | null | undefined): string {
  if (n == null) return "—";
  const sign = n > 0 ? "+" : "";
  return `${sign}${n.toFixed(1)}%`;
}

export default function TapeStrip() {
  const { data } = useTape();
  const { t } = useT();
  if (!data) return null;

  const pressure = data.market_pressure;
  const pressureLabel = pressure && PRESSURE_KEYS[pressure]
    ? t(PRESSURE_KEYS[pressure] as MessageKey)
    : pressure;

  return (
    <span className="block text-[10px] font-medium tracking-wider uppercase text-center">
      <span className="text-muted-foreground/65">BTC </span>
      <span className={pctColor(data.btc_change_24h)}>{fmtPct(data.btc_change_24h)}</span>
      <span className="text-muted-foreground/65"> / ETH </span>
      <span className={pctColor(data.eth_change_24h)}>{fmtPct(data.eth_change_24h)}</span>
      {pressureLabel && <span className="text-muted-foreground/55"> · {pressureLabel}</span>}
    </span>
  );
}
